import React, { useState } from 'react';
import { bool, shape } from 'prop-types';
import { faBook, faHeart, faSparkles } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Modal } from 'antd';

import FroalaEditorView from 'Src/common/components/froalaEditor/froalaEditorView';
import ModalHeader from 'Src/common/components/modalHeader';
import '../style.scss';

function InfoCard({ isMentor, connectionReport, showButton }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { programDetails } = window;

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const title = isMentor
    ? 'THANK YOU FOR CHOOSING TO BE A MENTOR'
    : `${connectionReport?.connections_available} CONNECTIONS AVAILABLE`;

  const guidelineText = isMentor ? 'Mentor' : 'Mentee';

  return (
    <Card className="info-card">
      <div className="arc-d-flex info-card-content">
        <FontAwesomeIcon icon={isMentor ? faHeart : faSparkles} />
        <div>
          <h6 className="arc-H150 arc-font-weight-bold-imp">{title}</h6>
          <Choose>
            <When condition={isMentor}>
              <p>
                We&apos;ll notify you on
                {` ${window.userData?.email || 'your email'} `}
                when we find someone that could use your help. Please note that when you receive an invite, you have{' '}
                <b>up to 14 days to accept the connection request.</b>
              </p>
            </When>
            <Otherwise>
              <p>
                Connections you make with others will appear here.{' '}
                <b>
                  You can have up to
                  {` ${connectionReport?.connections_max} `}
                  active connections at a time.
                </b>
              </p>
            </Otherwise>
          </Choose>
          <If condition={showButton}>
            <Button
              type="link"
              onClick={toggleModal}
              className="view-guidelines-btn"
              icon={<FontAwesomeIcon icon={faBook} className="mr8" />}>
              View {guidelineText} Guidelines
            </Button>
          </If>
        </div>
      </div>
      <Modal
        className="mentorship-guidelines-modal"
        visible={isModalOpen}
        closable={false}
        onCancel={toggleModal}
        title={<ModalHeader title="Guides" hasBackArrow onArrowClick={toggleModal} />}
        footer={
          <Button onClick={toggleModal} type="primary">
            Ok
          </Button>
        }>
        <div>
          <h2 className="arc-H500">Mentorship handbook</h2>
          <FroalaEditorView model={programDetails[`${guidelineText.toLowerCase()}_guidelines`]} />
        </div>
      </Modal>
    </Card>
  );
}

InfoCard.defaultProps = {
  showButton: true,
};

InfoCard.propTypes = {
  connectionReport: shape().isRequired,
  isMentor: bool.isRequired,
  showButton: bool,
};

export default InfoCard;
